import { render, staticRenderFns } from "./Dehumidifier.vue?vue&type=template&id=ec244642&"
import script from "./Dehumidifier.vue?vue&type=script&lang=js&"
export * from "./Dehumidifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports